import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatasourceDownstreamWorkbooksFilteredByFieldWithoutPersonalSpaceQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
`;
